<template>
  <div>
    <v-row>
      <v-col cols="12" sm="6" md="6" lg="4" class="ma-0 pa-0 pb-4 pt-2 pl-4">
        <v-select v-if="workflowStatus" :style="{fontWeight:700}"
          :items="getSelectedChecklists"
          @change="goToChecklistForm"
          item-text="name"
          item-value="id"
          v-model="getChecklist"
          :label="$t('message.layout.checklists')"
          dense
          hide-details
          outlined
        >
        </v-select>
      </v-col>
      <v-col cols="12" v-if="$vuetify.breakpoint.lgAndUp" sm="6" lg="4"></v-col>
    </v-row>
    <data-list :payload="modelObj" :headers="headers" v-model="pagination" :total="total" :pagination="pagination"></data-list>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import DataList from '@/components/DataList'
import helpers from '@/utils/checklistutils/download'
export default {
  props: ['module', 'filterObj', 'model', 'payload', 'propId', 'workflowStatus', 'productionObj'],
  data () {
    return {
      getChecklist: 0,
      modelObj: {
        hideOpen: true,
        isHeader: true,
        isHideAdd: true,
        selection: [],
        showSelect: true,
        hasPermission: true,
        hideSearch: true,
        addNewRoute: () => null,
        headers: [],
        list: [],
        isStock: true,
        hasFilters: false,
        relateClickHandler: () => null,
        loading: true,
        editProp: 'name',
        is_checklist: true,
        editHandler: this.updateChecklistDialog,
        hideTop: true,
        footer: true,
        fromCheckLsit: true,
        actionsList: [{
          click: (item) => this.downloadChecklist(item),
          icon: (item) => 'mdi-file-download',
          is_show: (item) => true,
          color: (item) => '#b42525'
        }],
        refreshHandler: this.getListHandler
      },
      total: 0,
      pagination: !this.$formatter.isEmptyObject(this.$store.state.PROPS_INDEX) ? this.$store.state.PROPS_INDEX : { sortBy: ['name'], itemsPerPage: 25, sortDesc: [false], search: '' },
      search: '',
      getSelectedChecklists: [],
      moduleName: 'checklists'
    }
  },
  components: {
    DataList
  },
  computed: {
    ...mapState(['userDetails']),
    ...mapGetters(['listOfModules']),
    headers () {
      return [{
        text: this.$t('message.props.name'),
        value: 'name',
        sortable: true,
        dbRef: 'Name'
      }, {
        text: this.$t('message.productionOrder.production_status'),
        value: 'workflowstate_name',
        sortable: true,
        dbRef: 'name'
      }, {
        text: `${this.$t('message.orders.updatedBy')}`,
        value: 'updated_by_user',
        sortable: true
      }, {
        text: `${this.$t('message.order.updatedOn')}`,
        value: 'updated_on',
        sortable: true
      }, {
        text: this.$t('message.props.actions'),
        value: 'actions',
        sortable: false
      }]
    }
  },
  watch: {
    search (val) {
      this.pagination.search = val
      this.getListHandler()
    },
    pagination (val) {
      this.getListHandler()
    }
  },
  created () {
    this.getListOfChecklists()
  },
  mounted () {
    const text = this.$t('message.common.deleteSuccess')
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.moduleName) {
        const payload = { ids: data.ids, url: `${this.moduleName}/delete_multiple`, module: this.moduleName }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.moduleName) {
        this.modelObj.selection = []
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getListHandler()
      }
    })
    this.$eventBus.$on('clearChecklist', () => {
      this.getChecklist = null
      this.getListHandler()
    })
  },
  methods: {
    downloadChecklist (item) {
      // eslint-disable-next-line
      let { checklist_id, form_id, name, id } = item
      this.$eventBus.$emit('showLoading')
      helpers.downloadReportHelper(checklist_id, form_id, name, process.env.VUE_APP_CHECKLIST_ACCESS_TOKEN, null, id, item.pdftemplatepath)
        .then(() => {
          this.$eventBus.$emit('hideLoading')
        })
    },
    getListOfChecklists () {
      const statusId = +this.workflowStatus || 0
      this.$_executeApi('post', `checklisttemplates/workflow_checklists/${statusId}`).then((response) => {
        this.getSelectedChecklists = response.data
      })
    },
    getListHandler () {
      this.modelObj.loading = true
      this.modelObj.module = this.moduleName
      const fields = this.$formatter.cloneVariable(this.headers)
      fields.splice(2, 1)
      fields.splice(1, 1)
      const { page, sortBy, sortDesc, itemsPerPage } = this.$formatter.cloneVariable(this.pagination)
      const pageVal = page || 1
      const additionalfilter = `productionorderitemid eq ${this.productionObj.id}`
      let sortByProp = sortBy[0] || ''
      if (sortByProp && sortByProp === 'modifiedname') sortByProp = 'name'
      const query = {
        order_by: {
          field: sortByProp,
          asc_or_desc: sortDesc[0] ? 'desc' : 'asc'
        },
        skip: ((pageVal - 1) * itemsPerPage),
        limit: itemsPerPage,
        include_count: true,
        filter: additionalfilter
      }
      query.expand = [{
        model: 'User',
        on_field: 'id',
        on_parent_field: 'updated_by'
      }]
      query.expand.push({
        select: ['pdftemplatepath', 'checklistheader', 'checklistfooter'],
        model: 'Checklist',
        on_field: 'id',
        on_parent_field: 'checklist_template_id'
      }, {
        select: ['name'],
        model: 'WorkflowState',
        on_field: 'id',
        on_parent_field: 'productionorderitemstatus'
      })
      const url = `${this.moduleName}/query`
      this.$_executeApi('post', url, query).then(async (response) => {
        this.modelObj.list = []
        const { values, count } = response.data
        this.modelObj.headers = this.headers
        values.forEach(async (x) => {
          x.updated_on = this.$formatter.formatDate(x.updated_on, 'DD.MM.YYYYTHH:mm:ss', 'DD.MM.YYYY HH:mm:ss')
          x.created_on = this.$formatter.formatDate(x.created_on, 'DD.MM.YYYYTHH:mm:ss', 'DD.MM.YYYY HH:mm:ss')
          x.updated_by_user = x.user_name || ''
          x.checklistmodule = this.module
        })
        this.modelObj.list = values
        this.total = count
      }).finally(() => {
        this.modelObj.loading = false
      })
    },
    goToChecklistForm () {
      const getForm = this.getSelectedChecklists.find(x => x.id === this.getChecklist)
      if (getForm) {
        this.$eventBus.$emit('checklistDialog', getForm)
      }
      return ''
    },
    updateChecklistDialog (item) {
      this.$eventBus.$emit('updatechecklistDialog', item)
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
    this.$eventBus.$off('clearChecklist')
  }
}
</script>
